import { WaitroseLogoSvg } from "./utils/WaitroseLogoSvg";
import classnames from "classnames/bind";
import styles from "./ClickAndCollectPreCountdownMessage.module.scss";

const cx = classnames.bind(styles);

type Props = {
  /**
   * A string representing the collect from local time tomorrow
   */
  collectFromLocalTimeTomorrow: string;
  /**
   * A boolean indicating whether to use new typography styles.
   */
  isNewTypographyEnabled: boolean;
};

export const ClickAndCollectPreCountdownMessageUI = ({
  collectFromLocalTimeTomorrow,
  isNewTypographyEnabled,
}: Props) => {
  return (
    <div
      className={styles.container}
      data-testid="pre-countdown-message"
      data-component="ClickAndCollectPreCountdown"
    >
      <WaitroseLogoSvg />
      <p
        className={cx("message", { newTypography: isNewTypographyEnabled })}
        data-testid="pre-countdown-message-text"
      >
        Collect from your nearest Waitrose from {collectFromLocalTimeTomorrow}{" "}
        tomorrow
      </p>
    </div>
  );
};
